var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6283 24.5212L26.3002 26.0503C26.8735 25.4235 27.3681 24.7275 27.7704 23.9816L25.7761 22.9062C25.4622 23.4884 25.0761 24.0318 24.6283 24.5212Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3491 26.6906L22.0974 28.829C22.8976 28.5491 23.6629 28.1692 24.372 27.7002L23.1221 25.8105C22.5691 26.1763 21.9725 26.4724 21.3491 26.6906Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5586 18.573L15.1687 20.6115L16.639 22.3353L19.8243 19.6184V13.6582H17.5586V18.573Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4926 21.0619L28.6899 21.6137C28.8956 20.7946 29 19.9475 29 19.0957H26.7344C26.7344 19.7616 26.653 20.4231 26.4926 21.0619Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6016 2.66992H24.2422V0.404297H21.9766V2.66992H7.02344V0.404297H4.75781V2.66992H3.39844C1.52454 2.66992 0 4.19446 0 6.06836V26.0059C0 27.8798 1.52454 29.4043 3.39844 29.4043H7.25H8.43945H11.4859C10.8899 28.9858 10.3258 28.5127 9.80007 27.987C9.52746 27.7144 9.26963 27.4311 9.02546 27.1387H8.43945H7.25H3.39844C2.7738 27.1387 2.26562 26.6305 2.26562 26.0059V10.9961H9.02551C9.26969 10.7037 9.52752 10.4203 9.80013 10.1477C10.3258 9.62211 10.8899 9.14899 11.4859 8.73047H2.26562V6.06836C2.26562 5.44373 2.7738 4.93555 3.39844 4.93555H4.75781V7.20117H7.02344V4.93555H21.9766V7.20117H24.2422V4.93555H25.6016C26.2262 4.93555 26.7344 5.44373 26.7344 6.06836V8.10742H29V6.06836C29 4.19446 27.4755 2.66992 25.6016 2.66992Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7344 12.6416C24.8096 10.2399 21.8754 8.78711 18.6914 8.78711C13.0072 8.78711 8.38281 13.4115 8.38281 19.0957C8.38281 24.7798 13.0072 29.4042 18.6913 29.4043C18.6916 29.4043 18.692 29.4043 18.6924 29.4043C18.9998 29.4043 19.3104 29.3905 19.6153 29.3634L19.4145 27.1067C19.176 27.1279 18.933 27.1387 18.6923 27.1387C18.692 27.1387 18.6917 27.1387 18.6915 27.1387L18.6914 28.2715V27.1387C14.2565 27.1387 10.6484 23.5306 10.6484 19.0957C10.6484 14.6608 14.2565 11.0527 18.6914 11.0527C21.2959 11.0527 23.6854 12.2992 25.1787 14.3379H22.7695V16.6035H29V10.373H26.7344V12.6416Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.a33318aa9c33f86e90c9a4209cd7b156.svg";
export { ForwardRef as ReactComponent };